/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import { getDashcamPurchases } from "../../../actions";
import Scrollbars from "react-custom-scrollbars";
import moment from "moment";
import { connect } from "react-redux";
import Statistics from "../../Statistics";

const headerElements = [
  { name: "User", width: "33%" },
  { name: "Phone", width: "33%" },
  { name: "Type", width: "34%" },
];

const DashcamPurchases = ({ getDashcamPurchases, dashcamPurchases, period, loading, setLoading, filtered }) => {
  const [curPage, setCurPage] = useState(2);
  const tableRef = useRef();
  const [innerLoading, setInnerLoading] = useState(false);
  const tableWidth = window.innerWidth < 1200 ? "160%" : "100%";

  const handleUpdate = (values) => {
    const { scrollTop, scrollHeight, clientHeight } = values;
    const pad = 0;
    const scrollableHeight = scrollHeight - clientHeight;
    if (scrollableHeight <= 0) return;
    const t = (Math.round(scrollTop) + pad) / scrollableHeight;
    if (t >= 0.97 && dashcamPurchases.totalPages >= curPage && !innerLoading) {
      setInnerLoading(true);
      getDashcamPurchases({
        pageNumber: curPage,
        limit: 10,
        ...period,
        createdAtFrom: period?.createdAtFrom || moment("2020-07-21").startOf("day").toISOString(),
        createdAtTo: period?.createdAtTo || moment().endOf("day").toISOString(),
        onSuccess: (res) => setInnerLoading(false),
      });
      setCurPage(curPage + 1);
    }
  };

  useEffect(() => {
    if (filtered) return;
    setLoading(true);
    getDashcamPurchases({
      pageNumber: 1,
      limit: 10,
      ...period,
      createdAtFrom: period?.createdAtFrom || moment("2020-07-21").startOf("day").toISOString(),
      createdAtTo: period?.createdAtTo || moment().endOf("day").toISOString(),
      onSuccess: (res) => {
        setLoading(false);
        setCurPage(2);
      },
    });
  }, []);

  useEffect(() => {
    if (filtered) {
      setLoading(true);
      getDashcamPurchases({
        pageNumber: 1,
        limit: 10,
        ...period,
        createdAtFrom: period?.createdAtFrom || moment("2020-07-21").startOf("day").toISOString(),
        createdAtTo: period?.createdAtTo || moment().endOf("day").toISOString(),
        onSuccess: (res) => {
          setLoading(false);
          setCurPage(2);
        },
      });
    }
  }, [period, filtered]);

  const typeLabel = (type) => {
    if (type === "cameraOnly") return "камера";
    if (type === "cameraAndAnnualSubscription") return "камера + абонамент 1 год";
    if (type === "cameraAndBiennialSubscription") return "камера + абонамент 2 год";
    return type || "---";
  };

  return (
    <>
      {loading === true ? (
        <div style={{ height: "90%" }}>{<Statistics.LoaderInline center />}</div>
      ) : (
        <>
          <div style={{ marginBottom: "15px", width: tableWidth }}>
            <h2 style={{ textTransform: "uppercase" }}>Dash Cam purchases</h2>
          </div>
          <Scrollbars
            style={{ height: "92%", width: tableWidth }}
            onUpdate={handleUpdate}
            ref={tableRef}
            id={"scrollbar"}
            renderView={(props) => <div {...props} style={{ ...props.style, overflowX: "hidden" }} />}
          >
            <div className="table-header">
              {headerElements?.map((header, i) => (
                <div className="header-cont" key={i} style={{ width: header.width }}>
                  <div className="header">{header.name}</div>
                </div>
              ))}
            </div>
            {dashcamPurchases?.docs?.map((row, i) => (
              <div className="table-body-row" key={row?._id || i}>
                <div className="row-data" style={{ width: "33%" }}>{row?.fullName || "---"}</div>
                <div className="row-data" style={{ width: "33%" }}>{row?.phoneNumber || "---"}</div>
                <div className="row-data" style={{ width: "34%" }}>{typeLabel(row?.type)}</div>
              </div>
            ))}
            {innerLoading && (
              <div className="inner-loader-container">
                <Statistics.LoaderInline center />
              </div>
            )}
          </Scrollbars>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  dashcamPurchases: state.app.dashcamPurchases,
});
const mapDispatchToProps = (dispatch) => ({
  getDashcamPurchases: (payload) => dispatch(getDashcamPurchases(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(DashcamPurchases);
